"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "card-cost-and-tags"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardCost = (0, vue_1.resolveComponent)("CardCost");
    const _component_card_help = (0, vue_1.resolveComponent)("card-help");
    const _component_CardTags = (0, vue_1.resolveComponent)("CardTags");
    const _component_CardTitle = (0, vue_1.resolveComponent)("CardTitle");
    const _component_CardContent = (0, vue_1.resolveComponent)("CardContent");
    const _component_CardExpansion = (0, vue_1.resolveComponent)("CardExpansion");
    const _component_CardResourceCounter = (0, vue_1.resolveComponent)("CardResourceCounter");
    const _component_CardVictoryPoints = (0, vue_1.resolveComponent)("CardVictoryPoints");
    const _component_CardExtraContent = (0, vue_1.resolveComponent)("CardExtraContent");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(["card-container filterDiv hover-hide-res", _ctx.cardClasses]),
        ref: "container"
    }, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
            class: "card-content-wrapper",
            onMouseover: _cache[0] || (_cache[0] = ($event) => (_ctx.hovering = true)),
            onMouseleave: _cache[1] || (_cache[1] = ($event) => (_ctx.hovering = false))
        }, [
            (!_ctx.isStandardProject)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                    (0, vue_1.createVNode)(_component_CardCost, {
                        amount: _ctx.cost,
                        newCost: _ctx.reducedCost
                    }, null, 8, ["amount", "newCost"]),
                    (_ctx.showPlayerCube)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: 0,
                            class: (0, vue_1.normalizeClass)(_ctx.playerCubeClass)
                        }, null, 2))
                        : (0, vue_1.createCommentVNode)("", true),
                    (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_card_help, {
                        name: _ctx.card.name
                    }, null, 8, ["name"]), [
                        [vue_1.vShow, _ctx.hasHelp]
                    ]),
                    (0, vue_1.createVNode)(_component_CardTags, { tags: _ctx.tags }, null, 8, ["tags"])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createVNode)(_component_CardTitle, {
                title: _ctx.card.name,
                type: _ctx.cardType
            }, null, 8, ["title", "type"]),
            (0, vue_1.createVNode)(_component_CardContent, {
                ref: "content",
                metadata: _ctx.cardMetadata,
                requirements: _ctx.cardRequirements,
                isCorporation: _ctx.isCorporationCard,
                bottomPadding: _ctx.bottomPadding
            }, null, 8, ["metadata", "requirements", "isCorporation", "bottomPadding"])
        ], 32)), [
            [_directive_i18n]
        ]),
        (0, vue_1.createVNode)(_component_CardExpansion, {
            expansion: _ctx.cardExpansion,
            isCorporation: _ctx.isCorporationCard,
            isResourceCard: _ctx.isResourceCard,
            compatibility: _ctx.cardCompatibility
        }, null, 8, ["expansion", "isCorporation", "isResourceCard", "compatibility"]),
        (_ctx.hasResourceType)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardResourceCounter, {
                key: 0,
                amount: _ctx.resourceAmount,
                type: _ctx.resourceType
            }, null, 8, ["amount", "type"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.cardMetadata.victoryPoints)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardVictoryPoints, {
                key: 1,
                victoryPoints: _ctx.cardMetadata.victoryPoints
            }, null, 8, ["victoryPoints"]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_CardExtraContent, { card: _ctx.card }, null, 8, ["card"]),
        (0, vue_1.renderSlot)(_ctx.$slots, "default")
    ], 2));
}
